export default __webpack_public_path__ + "static/media/tip21.4d82ba9b.png";